<template>
  <div>
    <h1>Home</h1>
  </div>
</template>

<script>
export default {
  name: "LimeLoansDashboardhomepage",

  metaInfo: {
    meta: [
      {
        name: "facebook-domain-verification",
        content: process.env.VUE_APP_FACEBOOK_DOMAIN_VERIFICATION,
      },
    ],
  },

  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped>
//
</style>
